// extracted by mini-css-extract-plugin
export default {"about_page":"AboutPage_about_page__blf0Z","schedule_section":"AboutPage_schedule_section__f5Pu6","headingx":"AboutPage_headingx__RXGBM"};